<template>
    <v-layout align-start>
        <v-flex>
            <v-app>
                <div>
                    <div>
                        <h2>Usuarios</h2>
                        <v-text-field v-model="search" append-icon="search" label="Buscar por nombres, apellidos o correo" outlined dense></v-text-field>
                        <v-divider class="mx-4" inset vertical></v-divider>                              
                        <!-- Diálogo para crear un nueva -->
                        <v-dialog v-model="dialog" max-width="50%">
                            <template v-slot:activator="{ on }">
                                <v-btn color="primary" dark class="mb-2" v-on="on" @click="nueva">Nuevo</v-btn>
                            </template>
                            <v-card>
                                <v-card-title>
                                    <span class="text-h5">{{ formTitle }}</span>
                                </v-card-title>
                                <v-card-text>
                                    <v-container grid-list-md>
                                        <v-layout wrap>
                                            <v-flex xs12 sm12 md3>
                                                <v-text-field v-model="dato.identificacion" label="Identificación"></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm12 md4>
                                                <v-text-field v-model="dato.nombres" label="Nombres"></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm12 md4>
                                                <v-text-field v-model="dato.apellidos" label="Apellidos"></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm12 md4>
                                                <v-text-field v-model="dato.correo" label="Correo"></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm12 md4>
                                                <v-select v-model="dato.oid_rol" :items="rols" item-text="n_rol" item-value="oid" label="Rol"></v-select>
                                            </v-flex>
                                            <v-flex xs12 sm12 md6>
                                                <v-text-field v-if="isNew" v-model="dato.pswd" label="Contraseña" type="password"></v-text-field> 
                                            </v-flex> 
                                        </v-layout>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" text @click="cerrar">Cancelar</v-btn>
                                    <v-btn color="blue darken-1" text @click="guardar">{{ isNew ? 'Crear' : 'Actualizar' }}</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </div>
                    <v-data-table :headers="headers" :items="filtered" item-key="oid">
                        <template v-slot:items="props">
                            <td>{{ props.item.identificacion }}</td>
                            <td>{{ props.item.nombres }}</td>
                            <td>{{ props.item.apellidos }}</td>
                            <td>{{ props.item.correo }}</td>
                            <td>{{ obtenerNombreR(props.item.oid_rol) }}</td>
                            <td class="text-center">
                                <v-btn small color="primary" @click="mostrar(props.item.oid)">Mostrar</v-btn>
                                <v-btn small color="warning" @click="editar(props.item)">Editar</v-btn>
                                <v-btn small color="error" @click="confirmarEliminar(props.item.oid)">Eliminar</v-btn>
                            </td>
                            </template>
                            <template v-slot:item.actions="{ item }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon small class="mr-2" v-on="on" @click="mostrar(item.oid)">mdivisibility</v-icon>
                                    </template>
                                        <span>Detalle</span>
                                </v-tooltip> 
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon small class="mr-2" v-on="on" @click="editar(item)">mdiedit</v-icon>
                                    </template>
                                        <span>Editar</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon small v-on="on" @click="confirmarEliminar(item.oid)">mdidelete</v-icon>
                                    </template>
                                        <span>Eliminar</span>
                                </v-tooltip>
                            </template>
                    </v-data-table>
                
                    <!-- Formulario de creación/edición -->      
                    <v-form ref="form" @submit.prevent="guardar">
                    </v-form>
                    <!-- Diálogo para ver detalle-->
                    <v-dialog v-model="dialogdetail" max-width="50%">
                        <v-card>
                        <v-card-title class="headline">Detalle</v-card-title>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12 sm12 md3>
                                        <v-text-field v-model="dato.identificacion" label="Identificación" readonly disabled class="rounded"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 md4>
                                        <v-text-field v-model="dato.nombres" label="Nombres" readonly disabled class="rounded"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 md4>
                                        <v-text-field v-model="dato.apellidos" label="Apellidos" readonly disabled class="rounded"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 md4>
                                        <v-text-field v-model="dato.correo" label="Correo" readonly disabled class="rounded"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 md4>
                                        <v-select v-model="dato.oid_rol" :items="rols" item-text="n_rol" item-value="oid" label="Rol" readonly disabled></v-select>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn color="secondary" text @click="cancelarDetalle">Cerrar</v-btn>
                        </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <!-- Diálogo de confirmación para eliminar -->
                    <v-dialog v-model="showConfirmDialog" max-width="500px">
                        <v-card>
                        <v-card-title class="headline">Confirmar eliminación</v-card-title>
                        <v-card-text>
                            ¿Estás seguro de que deseas eliminar este registro?
                        </v-card-text>
                        <v-card-actions>
                            <v-btn color="primary" text @click="eliminar(confirmItemId)">Sí</v-btn>
                            <v-btn color="secondary" text @click="cancelarEliminar">No</v-btn>
                        </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <!-- Dialogo para Mensaje cargando-->
                    <v-dialog v-model="dialog_guardando" max-width="550px"> 
                        <v-card>
                            <v-card-title class="headline">Guardando .....</v-card-title>
                        </v-card>
                    </v-dialog>

                    <!-- Mensaje de confirmación-->
                    <v-snackbar v-model="guardarExitoso" color="success" top>
                        Guardado exitosamente
                        <template v-slot:action="{ attrs }">
                            <v-btn color="success" text v-bind="attrs" @click="registroExitoso = false">Cerrar</v-btn>
                        </template>
                    </v-snackbar>
                </div>
            </v-app>
        </v-flex>
    </v-layout>
</template>
  
  <script>
  import axios from 'axios';
  
  export default {
    data() {
      return {
        datos: [],
        rols: [],
        dato: {
          oid: 0,
          identificacion: '',
          nombres: '',
          apellidos: '',
          correo: '',
          oid_rol: 0,
          pswd: '',
        },
        isNew: true,
        headers: [
            { text: 'Acciones', value: 'actions', sortable: false },
            { text: 'Identificación', value: 'identificacion' },
            { text: 'Nombres', value: 'nombres' },
            { text: 'Apellidos', value: 'apellidos' },
            { text: 'Correo', value: 'correo' },
            { text: 'Rol', value: 'nombre_rol' },
        ],
        dialog: false, // Controla la visibilidad del diálogo
        formTitle: '', // Título del diálogo
        dialogdetail: false,
        showConfirmDialog: false,
        confirmItemId: null,
        search: '', // Valor del campo de búsqueda
        dialog_guardando: false,
        guardarExitoso: false, 
      };
    },
    computed: {
        filtered() {
            let datos = this.datos.map(dato => {
                    return {
                        ...dato,
                        nombre_rol: this.obtenerNombreR(dato.oid_rol),
                    };
                }).filter(dato =>
                    dato.nombres.toLowerCase().includes(this.search.toLowerCase()) ||
                    dato.apellidos.toLowerCase().includes(this.search.toLowerCase()) ||
                    dato.correo.toLowerCase().includes(this.search.toLowerCase())
                );

                return datos;
        },
    },
    mounted() {
      this.listar();
    },
    methods: {
        // Obtener la lista
        async listar() {
            try {
                const response = await axios.get('api/Users/Listar');
                const responserol = await axios.get('api/Rols/Listar');

                this.datos = response.data;
                this.rols = responserol.data;
            } catch (error) {
                console.error(error);
            }
        },
        cerrar() {
            this.dialog = false;
        },
        obtenerNombreR(oid_rol) {
            const rol = this.rols.find((rol) => rol.oid === oid_rol);
            return rol ? rol.n_rol : '';                
        },
        
        // Mostrar detalles
        async mostrar(id) {
            try {
                const response = await axios.get(`api/Users/Mostrar/${id}`);
                this.dato = response.data;
                this.isNew = false;
                this.formTitle = 'Detalle Rol';
                this.dialogdetail = true;
            } catch (error) {
                console.error(error);
            }
        },

        // Abrir el diálogo para crear una nuevo
        nueva() {
            this.dato = { oid: 0, identificacion: '', nombres: '', apellidos: '', correo: '', oid_rol: 0};            
            this.isNew = true;
            this.formTitle = 'Crear Rol';
            this.dialog = true;
        },
        // Abrir el diálogo para actualizar
        editar(dato) {
            this.dato = { ...dato };
            this.isNew = false;
            this.formTitle = 'Actualizar Rol';
            this.dialog = true;
        },

        // Guardar creada o actualizada
        async guardar() {
            this.dialog_guardando = true;
            try {        
                if (this.isNew) {
                    // Crear el área
                    const respuestaCrear = await axios.post('api/Users/Crear', this.dato);
                } else {
                    // Actualizar el área
                    await axios.put(`api/Users/Actualizar`, this.dato);
                }

                // Limpiar el formulario después de guardar o actualizar
                this.dato = { oid: 0, identificacion: '', nombres: '', apellidos: '', correo: '', oid_rol: 0};
                // Después de guardar exitosamente el registro:
                this.guardarExitoso = true;
                this.dialog = false;
                await this.listar();
            }catch(error) {
                console.error(error);
            } finally {
                // Independientemente de si la solicitud tuvo éxito o no, detenemos el estado de carga.
                this.dialog_guardando = false;
            }
        },
        // Eliminar
        async eliminar(id) {
            try {
                await axios.delete(`api/Users/Eliminar/${id}`);
                this.listar();
                this.cancelarEliminar();
            } catch (error) {
                console.error(error);
            }
        },
        // Confirmar eliminación
        confirmarEliminar(id) {
            this.confirmItemId = id;
            this.showConfirmDialog = true;
        },
        // Cancelar eliminación
        cancelarEliminar() {
            this.confirmItemId = null;
            this.showConfirmDialog = false;
        },
        // Cancelar Detalle
        cancelarDetalle() {
            this.dialogdetail = false;
        },
    },
  };
</script> 
<style>
    h2 {
        margin-top: 24px;
        margin-bottom: 16px;
    }
</style>